import React from 'react'
import LayoutModal from '../../organisms/layoutModal/layout-modal'
import { GatsbyImage } from 'gatsby-plugin-image'
import './modal-dialog.scss'

const ModalDialog = props => {
  const { noScroll = false, onClose = () => {}, className = '', isLoginModal = false } = props

  return (
    <LayoutModal noScroll={noScroll} onClose={onClose}>
      <div className={`f-modal-dialog ${className + (isLoginModal ? ' is-login' : '')} `}>
        <i
          className="far fa-times f-modal-dialog__close-icon"
          onClick={onClose}
        ></i>

        {props.image && (
          <div className="f-modal-dialog__image-container">
            <GatsbyImage
              className="f-modal-dialog__image-container--image"
              image={props.image?.gatsbyImageData}
              alt={props.image?.description || ''}
            />
          </div>
        )}

        {props.content && (
          <div className={"f-modal-dialog__content"+ (isLoginModal ? ' is-login' : '')}>{props.content}</div>
        )}

        {props.buttons && (
          <div className="f-modal-dialog__buttons">{props.buttons}</div>
        )}
      </div>
    </LayoutModal>
  )
}

export default ModalDialog
